var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loading
      ? _c(
          "div",
          [
            _c(
              "b-form",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Opportunity Name",
                              "label-for": "mc-opp-name",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "mc-opp-name",
                                type: "text",
                                readonly: "",
                              },
                              model: {
                                value: _vm.opportunityId.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.opportunityId, "name", $$v)
                                },
                                expression: "opportunityId.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Customer / Lead",
                              "label-for": "cust-lead",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "cust-lead",
                                type: "text",
                                readonly: "",
                              },
                              model: {
                                value: _vm.opportunityId.leadClientName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.opportunityId,
                                    "leadClientName",
                                    $$v
                                  )
                                },
                                expression: "opportunityId.leadClientName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Assigned To",
                              "label-for": "assigned-to",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "assigned-to",
                                type: "text",
                                readonly: "",
                              },
                              model: {
                                value: this.salesPersonName,
                                callback: function ($$v) {
                                  _vm.$set(this, "salesPersonName", $$v)
                                },
                                expression: "this.salesPersonName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Status", "label-for": "status" } },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { "label-for": "status" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "status",
                                    type: "text",
                                    readonly: "",
                                  },
                                  model: {
                                    value: _vm.opportunityId.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.opportunityId, "status", $$v)
                                    },
                                    expression: "opportunityId.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Sales Stage",
                              "label-for": "sales-stage",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "sales-stage",
                                type: "text",
                                readonly: "",
                              },
                              model: {
                                value: _vm.opportunityId.stage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.opportunityId, "stage", $$v)
                                },
                                expression: "opportunityId.stage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { "label-for": "amt", label: "Amount" } },
                          [
                            _c(
                              "div",
                              { staticClass: "form-label-group" },
                              [
                                _vm.HasPermission(
                                  _vm.PermissionList.Sales_Finance
                                )
                                  ? _c("b-form-input", {
                                      attrs: {
                                        id: "amt",
                                        type: "number",
                                        readonly: "",
                                      },
                                      model: {
                                        value: _vm.opportunityId.estimateValue,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.opportunityId,
                                            "estimateValue",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "opportunityId.estimateValue",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Expected Close Date",
                              "label-for": "close-date",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "close-date",
                                value: "2023-12-01",
                                readonly: "",
                              },
                              model: {
                                value: _vm.expectedCloseDate,
                                callback: function ($$v) {
                                  _vm.expectedCloseDate = $$v
                                },
                                expression: "expectedCloseDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Open Date",
                              "label-for": "open-date",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "open-date", readonly: "" },
                              model: {
                                value: _vm.createdon,
                                callback: function ($$v) {
                                  _vm.createdon = $$v
                                },
                                expression: "createdon",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Close Date",
                              "label-for": "close-date",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "close-date", readonly: "" },
                              model: {
                                value: _vm.closeDate,
                                callback: function ($$v) {
                                  _vm.closeDate = $$v
                                },
                                expression: "closeDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Days In Funnel",
                              "label-for": "funnel-date",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "funnel-date", readonly: "" },
                              model: {
                                value: _vm.opportunityId.funnel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.opportunityId, "funnel", $$v)
                                },
                                expression: "opportunityId.funnel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Description",
                              "label-for": "Description",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "Description",
                                placeholder: "Description",
                                rows: "3",
                                readonly: "",
                              },
                              model: {
                                value: _vm.opportunityId.description,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.opportunityId,
                                    "description",
                                    $$v
                                  )
                                },
                                expression: "opportunityId.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }